import OpenDocIcon from '@/assets/admin_type_2.svg';
import OpenInterfaceIcon from '@/assets/admin_type_4.svg';
import { ConfigVersionTypeEnum } from '@/pages/home/type/configServerType';
import { TreeNodeTypeEnum } from '@/pages/home/type';

export const VersionList = [
  { name: 'develop', active: false },
  { name: 'audit', active: false },
  { name: 'master', active: true },
];

export enum Type {
  ONLINE = '1',
  OFFLINE = '2',
  DELETE = '3',
  MIGRATE = '4',
}

export const InterfaceOperation = [
  { key: Type.ONLINE, name: 'online' },
  { key: Type.OFFLINE, name: 'offline' },
  { key: Type.DELETE, name: 'delete' },
  { key: Type.MIGRATE, name: 'migrate' },
];

export enum ConfigType{
  ROUTER = 1,
  API,
  TEST,
  RELEASE,
}
export enum ModeType{
  FORM = 'form',
  CODE = 'code',
  PREVIEW = 'preview',
}

export const ConfigModeList = [
  { id: ModeType.FORM, label: 'form_mode', type: 'list' },
  { id: ModeType.CODE, label: 'code_mode', type: 'code' },
];

export const AppFrepLimit: any = {
  1: {
    qps: 20,
    qpm: 1200,
    qpd: 1728000,
  },
  2: {
    qps: 40,
    qpm: 2400,
    qpd: 3456000,
  },
  3: {
    qps: 80,
    qpm: 4800,
    qpd: 6912000,
  },
  4: {
    qps: 100,
    qpm: 6000,
    qpd: 8640000,
  },
  0: {
    qps: '',
    qpm: '',
    qpd: '',
  },
};

export const APPIDLevel = [1, 2, 3, 4];

export const Transport = [
  { value: 'buffered', label: 'buffered' },
  { value: 'framed', label: 'framed' },
];

export const ServerMethod = [
  { value: 'thrift', label: 'thrift' },
  { value: 'bizrpc', label: 'bizrpc' },
  { value: 'http', label: 'http' },
];

export const ApiConfigNav = [
  {
    name: 'api_manage',
    path: '/api_manager',
    index: 1,
    active: false,
  },
  {
    name: '',
    path: '',
    index: 2,
    active: true,
  },
];

export const ApiDiffSubmitNav = [
  {
    name: 'api_dev_version',
    path: '',
    index: 1,
    active: false,
  },
  {
    name: 'submit_online_preview',
    path: '',
    index: 2,
    active: true,
  },
];
export const ApiDiffPublishwNav = [
  {
    name: 'api_audit_version',
    path: '',
    index: 1,
    active: false,
  },
  {
    name: 'publish_online_preview',
    path: '',
    index: 2,
    active: true,
  },
];
export function ApiDiffPreviewNav(type: ConfigVersionTypeEnum) {
  return [
    {
      name: `api_${type}_version`,
      path: '',
      index: 1,
      active: false,
    },
    {
      name: 'check_online_preview',
      path: '',
      index: 2,
      active: true,
    },
  ];
}

export function getApiDiffNav(type: ConfigVersionTypeEnum) {
  return [
    {
      name: `api_${type}_version`,
      path: '',
      index: 1,
      active: false,
    },
    {
      name: 'submit_online',
      path: '',
      index: 2,
      active: true,
    },
  ];
}

export const AdminItemList = [
  {
    icon: OpenDocIcon,
    redirect: `${window.location.protocol}//${window.location.host}/gateway/document/home`,
    name: 'open_doc_admin_item',
  },
  {
    icon: OpenInterfaceIcon,
    redirect: `${window.location.protocol}//${window.location.host}/gateway/admin/api-audit`,
    name: 'open_interface_admin_item',
  },
];

export const HeaderConfig = [
  { id: 1, name: 'params_api_name', class: 'apiName' },
  { id: 2, name: 'params_type', class: 'apiType' },
  { id: 3, name: 'description', class: 'apiDesc' },
  { id: 4, name: 'params_set', class: 'apiValue' },
  // { id: 7, name: 'open_rang', class: 'openRang' },
  { id: 5, name: 'params_need', class: 'apiRequire' },
  { id: 6, name: 'params_opeartion', class: 'apiOperation' },
];

export const ResponseBody = [
  { id: 1, name: 'params_api_name', class: 'apiName' },
  { id: 2, name: 'params_type', class: 'apiType' },
  { id: 3, name: 'description', class: 'apiDesc' },
  { id: 4, name: 'params_set', class: 'apiValue' },
  // { id: 7, name: 'open_rang', class: 'openRang' },
  // { id: 5, name: 'rpc_rule', class: 'apiRule' },
  { id: 6, name: 'params_opeartion', class: 'apiOperation' },
];

export const TransfromPlugin = [
  { id: 1, name: 'plugin_func_name', class: 'pluginFuncName' },
  { id: 2, name: 'plugin_func_type', class: 'pluginFuncType' },
  { id: 3, name: 'plugin_func_param', class: 'pluginFuncParam' },
  { id: 4, name: 'plugin_func_description', class: 'description' },
  { id: 5, name: 'params_opeartion', class: 'operation' },
];

export const ResponseSource = [
  { id: 1, name: 'params_api_name', class: 'apiName' },
  { id: 2, name: 'params_type', class: 'apiType' },
  // { id: 3, name: 'description', class: 'apiDesc' },
  // { id: 4, name: 'params_set', class: 'apiValue' },
  // { id: 7, name: 'open_rang', class: 'openRang' },
  { id: 5, name: 'rpc_rule', class: 'apiRule' },
  // { id: 6, name: 'params_opeartion', class: 'apiOperation' },
];

export const RPCHeaderConfig = [
  { id: 1, name: 'param_name', class: 'rpcName' },
  { id: 2, name: 'rpc_type', class: 'rpcType' },
  { id: 3, name: 'rpc_need', class: 'rpcNeed' },
  { id: 4, name: 'rpc_rule', class: 'rpcRule' },
  { id: 5, name: 'params_opeartion', class: 'rpcOperation' },
];

export const LrHeaderConfig = [
  { id: 1, name: 'param_name', class: 'lrName' },
  { id: 2, name: 'rpc_type', class: 'rpcType' },
  // { id: 3, name: 'rpc_need', class: 'rpcNeed' },
  { id: 4, name: 'rpc_rule', class: 'lrRule' },
  { id: 5, name: 'params_opeartion', class: 'lrOperation' },
];

export const ReturnCodeConfig = [
  { id: 1, name: 'param_name', class: 'lrName' },
  { id: 4, name: 'rpc_rule', class: 'lrRule' },
];

export const CodeHeaderConfig = [
  { id: 1, name: 'service_code', class: 'serviceCode' },
  { id: 2, name: 'API_code', class: 'apiCode' },
  { id: 3, name: 'tip_message', class: 'message' },
  { id: 4, name: 'description', class: 'description' },
  { id: 5, name: 'solve_message', class: 'helpMessage' },
];

export const APIConfigType: TreeNodeTypeEnum[] = ['object', 'array', 'dict', 'string', 'number', 'boolean'];
export const APIConfigSubType = ['object', 'array', 'string', 'number', 'boolean'];
export const APIConfigSubType2 = ['string', 'number', 'boolean'];

export const WhiteList = [
  {
    name: 'white_app_ids',
    val: 'appId',
  },
  {
    name: 'white_developer_ids',
    val: 'developerId',
  },
  {
    name: 'white_advertiser_ids',
    val: 'advertiserId',
  },
];

export interface FormatType{
  [key: string]: string[];
}
export const Format: FormatType = {
  number: ['none', 'float', 'double', 'int32', 'int64'],
  string: ['none', 'date', 'datetime', 'binary', 'email'],
  object: [],
  array: [],
  boolean: [],
  dict: [],
};
